import { useState, useCallback } from 'react';
import { useUnmountedRef } from './useUnmountedRef.js';

// src/hooks/useSafeState.ts
function useSafeState(initialState) {
  const unmountedRef = useUnmountedRef();
  const [state, setState] = useState(initialState);
  const setCurrentState = useCallback((currentState) => {
    if (unmountedRef.current) return;
    setState(currentState);
  }, []);
  return [state, setCurrentState];
}

export { useSafeState };
